/* eslint-disable jsx-a11y/media-has-caption */
import React from "react";

import { Template } from "chq";

import { Modal } from "@culturehq/components";
import ChqModal from "components/common/ChqModal";
import { Preview } from "@creatomate/preview";
import Card from "./Card";

interface VideoCardProps {
  onSelectedTemplate: (template: Template) => void;
  template: Template;
  preview?: Preview;
}

const VideoCard: React.FC<VideoCardProps> = ({
  onSelectedTemplate, template, preview
}) => (
  <ChqModal
    className="Template-Modal"
    entrance="zoomIn"
    trigger={(onTrigger: () => void) => (
      <Card
        onSelectedTemplate={onSelectedTemplate}
        onTrigger={onTrigger}
        template={template}
        preview={preview}
      />
    )}
  >
    <Modal.Body>
      <div className="Template-BgImage" style={{ backgroundImage: `url(${template.posterUrl})` }} />
      <video
        autoPlay
        className="Template-Video"
        controls
        src={template.url}
        controlsList="nodownload"
      />
    </Modal.Body>
  </ChqModal>
);

export default VideoCard;
